(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

      this.setHeaderHeight =
        this.setHeaderHeight.bind(this);

    }

    connectedCallback() {

      this.header =
        document.querySelector('.section-header');

      this.mobileMediaQuery =
        window.matchMedia('(max-width: 990px)');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener(
        'change',
        this.setHeaderHeight
      );

      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }

      this.currentScrollTop =
        0;

      this.preventReveal =
        false;

      this.predictiveSearches =
        this.querySelectorAll(
          'predictive-search'
        );

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (
          this.preventReveal = true
        );

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();

    }

    setHeaderHeight() {

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      this.mobileMediaQuery.removeEventListener(
        'change',
        this.setHeaderHeight
      );

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      let observer =
        new IntersectionObserver(
          (entries, observer) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observer.disconnect();

          }
        );

      observer.observe(
        this.header
      );

    }

    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        [...this.predictiveSearches].some(
          (predictiveSearch) =>
            predictiveSearch.isOpen
        )
      ) {

        return;

      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          this.preventHide
        ) {

          return;

        }

        requestAnimationFrame(
          this.hide.bind(this)
        );

      }

      else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.preventReveal
        ) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        }

        else {

          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling =
            setTimeout(
              () => {

                this.preventReveal =
                  false;

              },
              66
            );

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      }

      else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );

      }

      this.currentScrollTop =
        scrollTop;

    }

    hide() {

      if (
        this.headerIsAlwaysSticky
      ) {

        return;

      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }

    reveal() {

      if (
        this.headerIsAlwaysSticky
      ) {

        return;

      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    reset() {

      if (
        this.headerIsAlwaysSticky
      ) {

        return;

      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }

    closeMenuDisclosure() {

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) =>
          disclosure.close()
      );

    }

    closeSearchModal() {

      this.searchModals =
        this.searchModals ||
        this.header.querySelectorAll(
          'details-modal'
        );

      this.searchModals.forEach(
        (searchModal) =>
          searchModal.close(false)
      );

    }

  }


  document.addEventListener(
    'open',

    (event) => {

      if (
        !(event.target instanceof HTMLElement) ||
        !event.target.matches(
          'shopify-account'
        )
      ) {

        return;

      }

      const bottom =
        Math.max(
          0,

          Math.round(
            event.target
              .getBoundingClientRect()
              .bottom
          )
        );

      event.target.style.setProperty(
        '--account-dialog-top',
        `${bottom}px`
      );

    },

    true
  );


  if (
    !customElements.get(
      'sticky-header'
    )
  ) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }


  /* =========================================================
     MEGA MENU POINTER MOTION
     ========================================================= */

  const initVelaroamMegaMenuMotion =
    (scope = document) => {

      scope
        .querySelectorAll(
          '.header__inline-menu .mega-menu__content'
        )
        .forEach(
          (panel) => {

            if (
              panel.dataset.velaroamMotionBound ===
              'true'
            ) {

              return;

            }

            panel.dataset.velaroamMotionBound =
              'true';

            panel.addEventListener(
              'pointermove',

              (event) => {

                if (
                  window
                    .matchMedia(
                      '(prefers-reduced-motion: reduce)'
                    )
                    .matches
                ) {

                  return;

                }

                const rect =
                  panel.getBoundingClientRect();

                if (
                  !rect.width ||
                  !rect.height
                ) {

                  return;

                }

                const x =
                  (
                    (
                      event.clientX -
                      rect.left
                    ) /
                    rect.width
                  ) *
                  100;

                const y =
                  (
                    (
                      event.clientY -
                      rect.top
                    ) /
                    rect.height
                  ) *
                  100;

                panel.style.setProperty(
                  '--vh-pointer-x',
                  `${
                    Math.max(
                      0,
                      Math.min(
                        100,
                        x
                      )
                    )
                  }%`
                );

                panel.style.setProperty(
                  '--vh-pointer-y',
                  `${
                    Math.max(
                      0,
                      Math.min(
                        100,
                        y
                      )
                    )
                  }%`
                );

              }
            );

            panel.addEventListener(
              'pointerleave',

              () => {

                panel.style.setProperty(
                  '--vh-pointer-x',
                  '50%'
                );

                panel.style.setProperty(
                  '--vh-pointer-y',
                  '34%'
                );

              }
            );

          }
        );

    };


  /* =========================================================
     REAL SHOPIFY IMAGE TEMPLATE INJECTION
     ========================================================= */

  const normalizeVelaroamMenuTitle =
    (value) => {

      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    };


  const initVelaroamMegaImages =
    (scope = document) => {

      const templates =
        Array.from(
          scope.querySelectorAll(
            '.velaroam-mega-template:not([data-velaroam-bound="true"])'
          )
        );

      templates.forEach(
        (template) => {

          template.setAttribute(
            'data-velaroam-bound',
            'true'
          );

          const wrapper =
            template.closest(
              '.header-wrapper'
            );

          if (
            !wrapper
          ) {

            return;

          }

          const megaMenus =
            Array.from(
              wrapper.querySelectorAll(
                '.header__inline-menu .mega-menu'
              )
            );

          if (
            megaMenus.length === 0
          ) {

            return;

          }

          const requestedTitle =
            normalizeVelaroamMenuTitle(
              template.dataset.menuTitle
            );

          let targetMegaMenu =
            megaMenus.find(
              (megaMenu) => {

                const summary =
                  megaMenu.querySelector(
                    'summary'
                  );

                if (
                  !summary
                ) {

                  return false;

                }

                const summaryTitle =
                  normalizeVelaroamMenuTitle(
                    summary.textContent
                  );

                return (
                  summaryTitle === requestedTitle ||
                  summaryTitle.includes(
                    requestedTitle
                  )
                );

              }
            );


          if (
            !targetMegaMenu
          ) {

            const fallbackIndex =
              Number(
                template.dataset.menuIndex
              );

            if (
              Number.isInteger(
                fallbackIndex
              ) &&
              megaMenus[fallbackIndex]
            ) {

              targetMegaMenu =
                megaMenus[fallbackIndex];

            }

          }


          if (
            !targetMegaMenu
          ) {

            return;

          }


          const content =
            targetMegaMenu.querySelector(
              '.mega-menu__content'
            );

          if (
            !content
          ) {

            return;

          }


          if (
            content.querySelector(
              '.velaroam-mega-media'
            )
          ) {

            return;

          }


          const clonedContent =
            template.content.cloneNode(
              true
            );


          content.insertBefore(
            clonedContent,
            content.firstChild
          );


          content.classList.add(
            'velaroam-has-media'
          );

        }
      );

    };


  /* =========================================================
     INITIAL LOAD
     ========================================================= */

  const initVelaroamHeader =
    (scope = document) => {

      initVelaroamMegaImages(
        scope
      );

      initVelaroamMegaMenuMotion(
        scope
      );

    };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',

      () => {

        initVelaroamHeader(
          document
        );

      },

      {
        once: true
      }
    );

  }

  else {

    initVelaroamHeader(
      document
    );

  }


  document.addEventListener(
    'shopify:section:load',

    (event) => {

      initVelaroamHeader(
        event.target
      );

    }
  );


  } catch(e) { console.error(e); }
})();
})();
